import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var Colon = props => {
  var {
    Colon: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Colon');
  return null;
};
Colon.displayName = 'JVR.Colon';